import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-rule bg-parchment-bone/40">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <p className="font-display text-2xl">Hearth <span className="italic text-wax-red">&amp;</span> Hermit</p>
          <p className="marginalia mt-3 max-w-md">
            An 18th-century courtesy, rekindled. A small middle finger to the housing crisis.
            Hermits and Hosts, well-met.
          </p>
        </div>
        <div>
          <p className="label-overline mb-3">Explore</p>
          <ul className="space-y-2 font-body">
            <li><Link to="/browse/hermitages" className="hover:text-wax-red">Hermitages</Link></li>
            <li><Link to="/browse/hermits" className="hover:text-wax-red">Hermits</Link></li>
            <li><Link to="/manifesto" className="hover:text-wax-red">Manifesto</Link></li>
            <li><Link to="/pricing" className="hover:text-wax-red">Pricing</Link></li>
          </ul>
        </div>
        <div>
          <p className="label-overline mb-3">Concerns</p>
          <ul className="space-y-2 font-body">
            <li><a href="mailto:hello@hearthandhermit.com" className="hover:text-wax-red">hello@hearthandhermit.com</a></li>
            <li><Link to="/press" className="hover:text-wax-red">Press kit</Link></li>
            <li><Link to="/privacy" className="hover:text-wax-red">Privacy</Link></li>
            <li><Link to="/terms" className="hover:text-wax-red">Terms</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-rule">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-sm text-ink-marginalia">© {new Date().getFullYear()} Hearth &amp; Hermit. Quietly built.</p>
          <p className="text-sm text-ink-marginalia italic">USA · UK · &amp; the kind reader</p>
        </div>
      </div>
    </footer>
  );
}
